import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Slider from 'react-slick';

import { Modal, notification } from 'antd';
import axios from 'axios';

import BrandLogo from 'components/common/BrandLogo';
import CheckBox from 'components/common/CheckBox';
import OpenNotification from 'components/common/CommonButton/OpenNotification';
import DownloadBlock from 'components/common/DownloadBlock';
import InputBlock from 'components/common/InputBlock';
import { SLIDER_SETTINGS } from 'components/common/Slider.settings';

import { Storage } from 'services/Storage';
import UtilService from 'services/util';

import { trim } from 'util/lodash';
import { isNotEmpty } from 'util/utils';
import { clone, isEmpty } from 'util/utils';

import { USER_DATA, USER_TOKEN_SET } from 'constants/ActionTypes';
import { BASE_URL } from 'constants/Common';
import { PROJECT_FULL_NAME } from 'constants/Common';
import { LOGIN_USER } from 'constants/apiConstant';

import Captcha from 'assets/js/Captcha';
import { setLoader } from 'redux/actions/Common';
import { store } from 'redux/store';

import bannerRrajeshJpg from 'assets/img/LoginBanner/banner-rrajesh.jpg';
import sidebarLogoPng from 'assets/img/sidebar_logo.png';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    const rememberMe = Storage.get('r-up') ?? false;
    const user = rememberMe ? Storage.get('up') : null;

    this.state = {
      formData: { username: user?.username ?? '', password: user?.password ?? '' },
      rememberMe,
      error: null,
      verifyEmail: false,
      errors: {},
    };
  }

  handleSubmit = () => {
    const reqObj = clone(this.state.formData);
    if (this.handleValidation()) {
      const obj = {
        ...LOGIN_USER,
        request: {
          ...reqObj,
          masters: [
            'COLOR',
            'CLARITY',
            'SHAPE',
            'CUT',
            'FLUORESCENCE',
            'SHADE',
            'LAB',
            'POLISH',
            'SYMMETRY',
            'LOCATION',
            'BLACK_INCLUSION',
            'OPEN_INCLUSION_TABLE',
            'MILKY',
            'WHITE_INCLUSION_CROWN',
            'OPEN_INCLUSION_CROWN',
            'EYECLEAN',
            'OPEN_INCLUSION_PAVILION',
            'ORIGIN',
            'BLACK_INCLUSION_CROWN',
            'H_AND_A',
            'WHITE_INCLUSION_TABLE',
            'FANCY_COLOR',
            'INTENSITY',
            'OVERTONE',
            'KEY_TO_SYMBOLS',
            'GIRDLE',
            'CULET',
            'GIRDLE_COND',
            'CULET_COND',
            'COMPANY_SIZE',
            'BLACK_INCLUSION_TABLE',
            'BLACK_INCLUSION_SIDE',
            'WHITE_INCLUSION_SIDE',
            'BRILLIANCY',
            'EYECLEAN',
            'BUSINESS_TYPE',
            'NATURE_OF_ORG',
            'DOC_TYPE_PERSONAL',
            'DOC_TYPE_BUSINESS',
            'OPEN_INCLUSION_PAVILION',
            'EXTRA_FACET_PAVILION',
            'EXTRA_FACET_CROWN',
            'GRAINING',
            'LUSTER',
            'DAY_TERM',
            'BILL_TYPE',
            'DELIVERY_TYPE',
          ],
        },
      };

      if (reqObj.captcha !== this.child.fetchCaptcha())
        return OpenNotification({
          type: 'error',
          title: 'Please enter correct captcha',
        });

      UtilService.callApi(obj, (err, res) => {
        if (err) {
          if (res.data.code === 'EMAIL_NOT_VERIFIED') {
            this.setState({ verifyEmail: true });
          } else {
            return OpenNotification({
              type: 'error',
              title: res.data.message || err.data.data.message || 'Failed to Login.',
            });
          }
        }
        if (res && res.code === 'OK') this.getRedirection(res);
      });
    }
  };

  handleOnChange = (key, value) => {
    const { formData } = this.state;
    formData[key] = value;
    this.setState(formData);
  };

  handleRememberMe = (e) => {
    this.setState({ rememberMe: e.target.checked }, () => {
      Storage.set('r-up', this.state.rememberMe);
    });
  };

  handleVerifyEmail = () => {
    const api = 'admin/v1/user/resendVerificationEmail';
    const obj = { username: this.state.username };
    const objData = { method: 'post', url: api, request: obj };
    UtilService.callApi(objData, (err, res) => {
      if (err) throw err;
      if (res && res.code === 'OK') {
        this.setState({ verifyEmail: false });
      }
    });
  };

  getRedirection = (res) => {
    const user = res.data.user;
    const fromRapnet = Storage.get('isDna');

    const masters = res.data.masters;
    const columns = res.data.columns;
    const userPermissions = res.data.userPermissions;
    const keywords = res.data.keywords;
    const token = res.data.token.jwt;
    const terms = res.data.user.accountTerm;

    Storage.set(`token`, token);
    Storage.set(`user`, user);

    Storage.set(`master`, masters, false);
    Storage.set(`column`, columns, false);
    Storage.set(`keywords`, keywords, false);
    Storage.set(`terms`, terms, false);
    Storage.set(`isTrusted`, res.data.isTrusted, false);

    const setPermit = {};
    void userPermissions?.data?.forEach?.((x) => {
      if (x.module === 'order' && user.Setting) {
        x.permissions.insert = user.Setting.Is_PlaceOrder ? user.Setting.Is_PlaceOrder : false;
      }

      if (x.module === 'pricing' && user.Setting && user.Setting.Is_NoPrice !== true) {
        x.permissions.view = !user.Setting.Is_NoPrice;
        x.permissions.all = !user.Setting.Is_NoPrice;
      }

      setPermit[x.module] = x.permissions;
    });

    if (setPermit && !setPermit.pricing) {
      if (user.Setting && user.Setting.Is_NoPrice !== true) {
        setPermit.pricing = {};
        setPermit.pricing.view = !user.Setting.Is_NoPrice;
        setPermit.pricing.all = !user.Setting.Is_NoPrice;
      }
    }

    Storage.set(`userPermissions`, setPermit);
    Storage.set('r-up', this.state.rememberMe);
    if (this.state.rememberMe) {
      Storage.set('up', { username: this.state.formData.username, password: this.state.formData.password });
    } else {
      Storage.delete('up');
    }
    Storage.delete('visited-fields');

    axios.defaults.headers.common['access-token'] = 'JWT ' + token;

    store.dispatch({ type: USER_DATA, payload: user });
    store.dispatch({ type: USER_TOKEN_SET, payload: token });

    if (fromRapnet) {
      this.props.history.push('/diamond-detail/' + fromRapnet);
    } else {
      this.props.history.push('/dashboard');
    }
  };

  handleValidation = () => {
    let formIsValid = true;

    const formData = this.state.formData;
    const errors = this.state.errors;

    const blankField = [];
    const invalidFiels = [];

    if (!formData['username'] || isEmpty(formData['username'])) {
      blankField.push('User Name');
      errors['username'] = true;
      formIsValid = false;
    }
    if (!formData['password'] || isEmpty(formData['password'])) {
      blankField.push('Password');
      errors['password'] = true;
      formIsValid = false;
    }
    if (!formData['captcha'] || isEmpty(formData['captcha'])) {
      blankField.push('captcha');
      errors['captcha'] = true;
      formIsValid = false;
    }

    if (blankField.length > 0) {
      const arr = blankField;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }

      notification.error({
        message: 'Required Fields',
        placement: 'topRight',
        description: outStr,
      });
    }

    if (invalidFiels.length > 0) {
      const arr = invalidFiels;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }

      notification.error({
        message: 'Invalid Fields',
        placement: 'topRight',
        description: outStr,
      });
    }

    this.setState({ errors: errors });
    return formIsValid;
  };

  render() {
    const { formData, rememberMe, errors } = this.state;
    const { activeBanners = [] } = this.props;
    const message = activeBanners.filter((item) => item?.type === '25')?.[0];
    const bannerImagePaths = activeBanners.filter((item) => item?.type === '26')?.[0]?.images?.filter(isNotEmpty) ?? [];

    return (
      <div className="bg-color-aq">
        <div className="loginMainWrapper justify-content-center">
          <div className="LoginLeftBlock w-70">
            {isNotEmpty(message?.description) && (
              <marquee className="marquee-inner" width="100%" direction="left">
                {message.description}
              </marquee>
            )}
            {isNotEmpty(bannerImagePaths) ? (
              bannerImagePaths.length === 1 ? (
                <img
                  style={{ width: '100%', height: '100%', position: 'sticky', objectFit: 'cover' }}
                  src={`${BASE_URL}${bannerImagePaths[0]}`}
                />
              ) : (
                <Slider className="arrow-l-r" {...SLIDER_SETTINGS} style={{ width: '100%', height: '100%' }}>
                  {bannerImagePaths?.map((path) => (
                    <div key={path}>
                      <img style={{ width: '100%', height: '100%', objectFit: 'cover' }} src={`${BASE_URL}${path}`} />
                    </div>
                  ))}
                </Slider>
              )
            ) : (
              <img
                style={{ width: '100%', height: '100%', position: 'sticky', objectFit: 'cover' }}
                src={bannerRrajeshJpg}
              />
            )}
          </div>
          <div className="LoginRightBlock">
            <div className="loginDetail d-flex align-center login-page-rr">
              <div className="width-100 mobile-375">
                <div className="loginHead text-center">
                  <div className="closeImage pb-3">
                    <img className="loginicon" src={sidebarLogoPng} alt="" />
                  </div>
                  <h3>Welcome to {PROJECT_FULL_NAME}</h3>
                  <DownloadBlock />
                </div>
                <div className="loginBox">
                  <InputBlock
                    onChange={(e) => this.handleOnChange('username', trim(e.target.value))}
                    value={formData.username}
                    type="text"
                    label="Login ID"
                    placeholder="Enter Username or Email"
                    hasError={errors['username']}
                  />

                  <InputBlock
                    onChange={(e) => this.handleOnChange('password', e.target.value)}
                    value={formData.password}
                    type="password"
                    label="Password"
                    hasError={errors['password'] ? true : false}
                    placeholder="Enter Password"
                    loginKeyDown={() => {
                      if (formData.username && formData.password) {
                        this.handleSubmit();
                      }
                    }}
                  />

                  <div className="d-flex j-space-between align-items-center flex-wrap">
                    <InputBlock
                      onChange={(e) => this.handleOnChange('captcha', e.target.value)}
                      value={formData.captcha}
                      type="captcha"
                      label="Captcha"
                      hasError={errors['captcha'] ? true : false}
                      placeholder="Enter captcha"
                      loginKeyDown={() => {
                        if (formData.username && formData.captcha) {
                          this.handleSubmit();
                        }
                      }}
                    />
                    <Captcha
                      onRef={(ref) => {
                        this.child = ref;
                      }}
                    />
                  </div>
                  <div className="d-flex j-space-between align-items-center loginLinkBlock">
                    <div className="rememberCheckBox">
                      <CheckBox
                        id="remember-check"
                        checked={rememberMe === 'true' || rememberMe === true ? true : false}
                        onChange={this.handleRememberMe}
                      />
                      <span className="rememberLabel">Remember Me</span>
                    </div>
                    <Link to="/forgot-password" className="primary-text forgot-password text-style">
                      Forgot Password?
                    </Link>
                  </div>
                  <div className="loginButton">
                    <button className="commonButton" onClick={this.handleSubmit.bind(this)}>
                      Login
                    </button>
                    <button onClick={() => this.props.history.push('/guest-login')} className="commonOutline pad-lr-30">
                      Guest Login
                    </button>
                  </div>
                  {/* <div className="loginButton jus-center">
                      <a target="_blank" href="https://rrajesh.co/SessionExpired.aspx">
                        <button className="commonButton sepret-btn" href="https://rrajesh.co/SessionExpired.aspx">
                          Login to Old Web System
                        </button>
                      </a>
                    </div> */}
                  {this.state.verifyEmail && (
                    <Modal
                      centered
                      visible={this.state.verifyEmail}
                      title={[
                        <h2 key="deletebuttonH2" className="modal__title primary-text" id="modal-1-title">
                          Email Verification
                        </h2>,
                      ]}
                      onCancel={() => this.setState({ verifyEmail: false })}
                      footer={[
                        <div key="deletebuttonReminder">
                          <center>
                            {/* <button
                                className="modal__btn button primary-fill"
                                style={{ padding: '9px 25px' }}
                                onClick={this.handleVerifyEmail}
                              >
                                Resend Verify Email
                              </button> */}
                            <button
                              className="button button-outline primary-fill"
                              style={{ padding: '9px 25px' }}
                              onClick={() => this.setState({ verifyEmail: false })}
                            >
                              Cancel
                            </button>
                          </center>
                        </div>,
                      ]}
                      width={620}
                    >
                      <h3 align="center" style={{ color: 'rgba(0,0,0,0.70)' }}>
                        Your registered email hasn't verified yet. Please contact Admin or check your mail for
                        verification link. Thank you.
                      </h3>
                    </Modal>
                  )}
                </div>
                <div className="registerLogLink">
                  Don’t have login details?
                  <Link to="/signup">Register</Link>
                </div>
                <BrandLogo />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    (state) => ({
      token: state.auth?.token,
    }),
    { setLoader },
  )(LoginForm),
);
